if (!customElements.get('community-video-grid')) {
  class CommunityVideoGrid extends HTMLElement {
    connectedCallback() {
      this.tiles = Array.from(this.querySelectorAll('.community-video-grid__tile'));

      this.tiles.forEach((tile) => {
        const video = tile.querySelector('video');
        if (!video) return;

        tile.addEventListener('click', () => {
          if (video.paused) {
            this.loadVideo(video);
            this.pauseAll(tile);
            video.muted = false;
            video.play();
            tile.classList.add('is-playing');
          } else {
            video.pause();
            tile.classList.remove('is-playing');
          }
        });

        video.addEventListener('ended', () => tile.classList.remove('is-playing'));
      });
    }

    // Nothing downloads until a tile is actually tapped - see the
    // section comment for why this stays fully lazy rather than
    // using preload="metadata" for a free thumbnail.
    loadVideo(video) {
      if (!video.dataset.lazySrc) return;
      video.src = video.dataset.lazySrc;
      video.preload = 'auto';
      delete video.dataset.lazySrc;
    }

    pauseAll(except) {
      this.tiles.forEach((tile) => {
        if (tile === except) return;
        const video = tile.querySelector('video');
        if (video && !video.paused) video.pause();
        tile.classList.remove('is-playing');
      });
    }
  }

  customElements.define('community-video-grid', CommunityVideoGrid);
}
